import { Icon, IconProps } from './Icon';

interface LuxuryIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const LuxuryIcon = ({ color = '#C2E2FF', gradient, ...props }: LuxuryIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M38.3369 39.5936H6.65811C6.02235 39.5936 5.48374 39.1265 5.39341 38.4959L2.05781 15.2626C1.98792 14.7717 2.20609 14.2859 2.62027 14.0132C3.03445 13.7388 3.56965 13.732 3.99065 13.9911L13.6941 19.9345L21.3828 6.15915C21.8345 5.34954 23.164 5.34954 23.6156 6.15915L31.3044 19.9345L41.0078 13.9911C41.4305 13.7337 41.964 13.7405 42.3782 14.0132C42.7924 14.2859 43.0122 14.7717 42.9406 15.2626L39.605 38.4976C39.513 39.1265 38.9744 39.5936 38.3369 39.5936Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
